@if (isVisible) {
    <div
        (mouseleave)="closeDropdown.emit(null)"
        class="absolute px-8 py-4"
        [ngClass]="dropdownPositionClassName">
        <div
            class="absolute left-2/4 h-[10px] w-[10px] rotate-45 rounded-tl-sm bg-white"></div>
        <div
            class="mt-1 w-[300px] rounded-lg bg-white p-2 shadow-2xl"
            [ngClass]="dropdownContainerClassName">
            <ng-content></ng-content>
        </div>
    </div>
}
